import { render, staticRenderFns } from "./fila-consultas.vue?vue&type=template&id=73a9cf2c&scoped=true&"
import script from "./fila-consultas.vue?vue&type=script&lang=js&"
export * from "./fila-consultas.vue?vue&type=script&lang=js&"
import style0 from "./fila-consultas.vue?vue&type=style&index=0&id=73a9cf2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a9cf2c",
  null
  
)

export default component.exports